import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import gql from 'graphql-tag';
import { normalizeInputValue } from 'localmed-core';

import GlobalInsuranceIssuerSelect from './GlobalInsuranceIssuerSelect';

export const DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY = gql`
  query GlobalInsuranceIssuerSelectDefaultSelectedInsuranceIssuerData($id: ID!) {
    insuranceIssuer(id: $id) {
      id
      display
      state
    }
  }
`;

const addDefaultSelectedInsuranceIssuerData = graphql(DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY, {
  name: 'defaultSelectedInsuranceIssuerData',
  alias: 'withDefaultSelectedInsuranceIssuerData',
  skip: ({ initialSelectedValue }) => initialSelectedValue == null,
  options({ initialSelectedValue }) {
    return { variables: { id: initialSelectedValue }, ssr: false };
  },
});

export const FEATURED_DATA_QUERY = gql`
  query GlobalInsuranceIssuerSelectFeaturedData($countryCode: String!, $perPage: Int!) {
    insuranceIssuers(featured: true, countryCode: $countryCode, perPage: $perPage) {
      nodes {
        id
        display
        state
      }
    }
  }
`;

const addFeaturedData = graphql(FEATURED_DATA_QUERY, {
  name: 'featuredData',
  alias: 'withFeaturedData',
  skip: ({ isOpen }) => !isOpen,
  options({ countryCode }) {
    return {
      variables: {
        countryCode,
        perPage: parseInt(global.CLIENT_ENV.TOP_INSURANCES_COUNT, 10),
      },
      ssr: false,
    };
  },
});

export const AUTOCOMPLETE_DATA_QUERY = gql`
  query GlobalInsuranceIssuerSelectAutocompleteData($autocomplete: String!, $countryCode: String!) {
    insuranceIssuers(autocomplete: $autocomplete, countryCode: $countryCode) {
      nodes {
        id
        display
        state
      }
    }
  }
`;

const addAutocompleteData = graphql(AUTOCOMPLETE_DATA_QUERY, {
  name: 'autocompleteData',
  alias: 'withAutocompleteData',
  skip({ inputValue, selectedItem, toLabel }) {
    inputValue = normalizeInputValue(inputValue);
    return inputValue.length < 2 || normalizeInputValue(toLabel(selectedItem)) === inputValue;
  },
  options({ inputValue, countryCode }) {
    return {
      variables: { autocomplete: normalizeInputValue(inputValue), countryCode },
      ssr: false,
    };
  },
});

export default compose(
  addDefaultSelectedInsuranceIssuerData,
  addFeaturedData,
  addAutocompleteData
)(GlobalInsuranceIssuerSelect);
